import React from 'react';
import { compose } from 'redux';
import { RESORT_TAGS } from 'Cms/constants';
import type { GQLProps, CMSProps } from 'Cms/product-tags/resolver';
import { getProductProps, setProductHref } from 'Components/widgets/product/Product.mapper';
import { addTranslationKeys } from 'Src/i18n';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { ProductTags } from 'Components/widgets/product-tags/ProductTags';
export type LineProps = CMSProps & GQLProps;
export const ProductTagsLine = ({
  config,
  id,
  products,
  seeAllProductsLink,
  tags,
  title,
}: LineProps) => {
  const trackingData = {
    actionGA: 'push_content_IdealResort',
  };
  const track = useTracking(trackingData);

  if (!tags || tags.length === 0 || !products || products.length === 0) {
    return null;
  }

  addTranslationKeys(config);
  const formattedProducts = products.map((product) =>
    compose(
      getProductProps,
      setProductHref,
    )({
      config,
      product,
      isSliderDisabled: true,
    }),
  );
  const tagsWithProducts = tags
    .map((tag) => {
      const productsInTag = tag.productIds
        .map((productId) => formattedProducts.find((p) => p.id === productId))
        .filter(Boolean);
      return productsInTag.length > 0 ? { ...tag, products: productsInTag } : null;
    })
    .filter(Boolean);
  return (
    tagsWithProducts.length > 0 && (
      <SiteContainer className="Line" data-testid="Line-ProductTags" id={id}>
        <div className="flex flex-wrap justify-between">
          <LineTitle className="flex-1 md:flex-none">{title}</LineTitle>
          <DynamicLink
            className="order-last m-auto mt-15 text-14 text-black underline hocus:text-black-active md:order-0 md:mx-0 md:mt-5"
            onClick={() =>
              track({
                labelGA: 'seeAllResorts',
              })
            }
            url={seeAllProductsLink.url}
          >
            {seeAllProductsLink.label}
          </DynamicLink>
          <ProductTags lineName={RESORT_TAGS} tags={tagsWithProducts} trackingData={trackingData} />
        </div>
      </SiteContainer>
    )
  );
};
